import { createContext } from 'react'

export const EMAIL_CHANGE_OTP_LENGTH = 6

type EmailChangeStep = 'email' | 'current-code' | 'new-code' | 'done'

type EmailChangeState = {
  step: EmailChangeStep
  newEmail: string
  code: string
  error: string
  submitting: boolean
}

type EmailChangeAction =
  | { type: 'SET_NEW_EMAIL'; payload: string }
  | { type: 'SET_CODE'; payload: string }
  | { type: 'SUBMIT_START' }
  | { type: 'SET_ERROR'; payload: string }
  | { type: 'CODE_SENT'; step: 'current-code' | 'new-code' }
  | { type: 'CHANGED' }
  | { type: 'RESET' }

type EmailChangeContextType = {
  state: EmailChangeState
  dispatch: React.Dispatch<EmailChangeAction>
  currentEmail: string
  /** where the code on screen was sent. */
  codeAddress: string
  resendCooldown: number
  start: () => Promise<void>
  confirmCode: (otp: string) => Promise<void>
  resend: () => Promise<void>
  reset: () => void
}

export const EmailChangeContext = createContext<EmailChangeContextType | null>(
  null
)

export type {
  EmailChangeAction,
  EmailChangeContextType,
  EmailChangeState,
  EmailChangeStep
}
